import { createSvgIcon } from '@mui/material/utils'

const WarningDish = createSvgIcon(
  <>
    <path
      d="M0.5 66.37H89.52C89.52 69.04 87.35 71.21 84.68 71.21H5.34C2.67 71.21 0.5 69.04 0.5 66.37Z"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path d="M44.38 36.87L27.35 66.37H61.41L44.38 36.87Z" stroke="#204ECF" strokeMiterlimit="10" />
    <path
      d="M32.86 9.83C45.3 -2.61 65.48 -2.61 77.92 9.83C90.36 22.27 90.36 42.45 77.92 54.89L32.86 9.83Z"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M46.1899 7.82001C55.5099 4.34001 66.4199 6.34001 73.9099 13.84"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M80.62 11.23C82.1388 11.23 83.37 9.99879 83.37 8.48001C83.37 6.96123 82.1388 5.73001 80.62 5.73001C79.1012 5.73001 77.87 6.96123 77.87 8.48001C77.87 9.99879 79.1012 11.23 80.62 11.23Z"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M43.816 56.24L44.032 50.696H42.496L42.724 56.24H43.816ZM43.276 58.82C43.732 58.82 44.104 58.436 44.104 57.98C44.104 57.536 43.732 57.152 43.276 57.152C42.82 57.152 42.436 57.536 42.436 57.98C42.436 58.436 42.82 58.82 43.276 58.82Z"
      fill="#204ECF"
    />
  </>,
  'WarningDish'
)

export default WarningDish
